import React from 'react';
import { Text, DesktopWrap, UnsavedChangesDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const UnsavedChanges = ({
    onClose,
    onDiscard,
    continueText,
    fromSettingsClose,
    fromMore,
    isFromOrderListingPage=false,
    isFromSummary=false,
}) => {
    const {t} = useTranslation();
    return (
        <>
            <Popup
                title={isFromOrderListingPage ? t('scheduleSurgery.surgery.notifications.UnsavedChanges.EventNotification'):t('scheduleSurgery.surgery.notifications.UnsavedChanges.UnSavedChanges')}
                id={'surgery-notification-unsavedChanges-popup'}
                onClose={fromSettingsClose ? fromSettingsClose : onClose}
                img={AlertCircleOutline}
                fromMore={fromMore}
                isUnsavedPage={true}
                zIndex={isFromSummary ? 99999 : undefined}
            >
                <UnsavedChangesDiv divHeight={'140px'} divWidth={isFromOrderListingPage&&'400px'}mbDivHeight={isFromOrderListingPage&&'190px'}>
                    <Text
                        flexGrow={'1'}
                        height={'auto'}
                        font={'14px Avenir Next World'}
                        lineHeight={'20px'}
                    >
                   {isFromOrderListingPage ?t('scheduleSurgery.surgery.notifications.UnsavedChanges.EventNotificationText'):t('scheduleSurgery.surgery.notifications.UnsavedChanges.unSavedChangesLostText')}
                    </Text>
                    <DesktopWrap flexDirection="row-reverse" justifyContent="center">
                       <Button 
                         id={'surgery-notifications-unsavedchanges-continueediting'}
                            show={true}
                            width={'308px'}
                            mobileWidth={'308px'}
                            height={'38px'}
                            variant={ButtonStyles?.primary}
                           //primary={true}
                            borderRadius={'19px'}
                            margin={'5px'}
                            fontSize={'15px'}
                            fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {continueText
                                    ? continueText
                                    :isFromOrderListingPage?t('reportUsage.common.no'): t('scheduleSurgery.surgery.notifications.UnsavedChanges.continueEditingBtn')}
                            </div>
                        </Button>
                        <Button
                            id={'surgery-notifications-unsavedchanges-discardchangesandexitbtn'}
                            show={true}
                            variant={ButtonStyles?.discard}
                            // discard={true}
                            width={'308px'}
                            mobileWidth={'308px'}
                            height={'38px'}
                            margin={'5px'}
                            fontSize={'15px'}
                            clicked={onDiscard}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                             { isFromOrderListingPage? t('reportUsage.common.yes'): t('scheduleSurgery.surgery.notifications.UnsavedChanges.discardChangesAndExitBtn')}
                            </div>
                        </Button>
                    </DesktopWrap>
                </UnsavedChangesDiv>
            </Popup>
        </>
    );
};

export default UnsavedChanges;
